import { ViewModel, View } from "binder";
import { getAsBoolean, getAsNumber } from "../../../utilities";
import { ColumnFilter } from "../columnFilter";
import  { NumericFilterView } from "./numericFilter-view"

export class NumericFilterViewModel extends ColumnFilter{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new NumericFilterView();
    }
    public getTypeId(): string {
        return "VM-E29D4544-4B80-4729-9101-FEF44014A722"
    }
    public set largerThan(v: number) { this._largerThan = getAsNumber(v,true); } public get largerThan(): number { return this._largerThan;} private _largerThan: number;
    public set smallerThan(v: number) { this._smallerThan = getAsNumber(v,true); } public get smallerThan(): number { return this._smallerThan;} private _smallerThan: number;
    public set applylarger(v: boolean) { this._applylarger =getAsBoolean(v); } public get applylarger(): boolean { return this._applylarger;} private _applylarger: boolean;
    public set applySmaller(v: boolean) { this._applySmaller =getAsBoolean(v); } public get applySmaller(): boolean { return this._applySmaller;} private _applySmaller: boolean;
}
